import { render, staticRenderFns } from "./BaseMutiInput.vue?vue&type=template&id=2fb4340e&scoped=true"
import script from "./BaseMutiInput.vue?vue&type=script&lang=js"
export * from "./BaseMutiInput.vue?vue&type=script&lang=js"
import style0 from "./BaseMutiInput.vue?vue&type=style&index=0&id=2fb4340e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4340e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb4340e')) {
      api.createRecord('2fb4340e', component.options)
    } else {
      api.reload('2fb4340e', component.options)
    }
    module.hot.accept("./BaseMutiInput.vue?vue&type=template&id=2fb4340e&scoped=true", function () {
      api.rerender('2fb4340e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseMutiInput.vue"
export default component.exports